<template>
	<modal class="payment-confirmation-modal" @close="close" :size='"medium"'>
		<template slot="header">
			<h3><b>{{ 'Payment Confirmation' }}</b></h3>
		</template>
		<template slot="body">
			<div v-if="billing">
				<div class="form-group">
					<label class="text-bold">Order ID</label>
					<input
						class="form-control"
						type="text"
						v-model="orderId"
						disabled
					/>
				</div>

				<div class="form-group">
					<label class="text-bold">Atas Nama Rekening</label>
					<input
						class="form-control"
						type="text"
						placeholder="Nama Pemilik Rekening"
						v-model="bankOwnerName"
						disabled
					/>
				</div>

				<div class="form-group">
					<label class="text-bold">Transfer Ke</label>
					<textarea
						class="form-control"
						v-model="formatBankAccount"
						disabled
					/>
				</div>

				<div class="form-group">
					<label class="text-bold">Tanggal Transfer</label>
					<input
						class="form-control"
						type="date"
						placeholder="Tanggal Transfer"
						v-model="transferDate"
						disabled
					/>
				</div>

				<div class="form-group">
					<label class="text-bold">Jumlah Transfer</label>
					<input
						class="form-control"
						type="text"
						placeholder="Jumlah Transfer"
						v-model="transferAmount"
						disabled
					/>
				</div>

				<div class="form-group">
					<label class="text-bold">Bukti Transfer</label>
					<div class="mb-2 w-100">
						<img :src="paymentReceipt" class="border-grey border-radius-8" />
					</div>
				</div>
			</div>
		</template>
		<template slot="footer">
			<button class="btn btn-light" @click="close">
				{{ $t('Close') }}
			</button>
		</template>
	</modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
	props: {
		billing: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	methods: {
		close() {
			this.$emit('close');
		},
	},
	computed: {
		orderId() {
			return this.billing?.data?.order_id ?? '';
		},
		paymentConfirmation() {
			return this.billing?.payment_confirmation ?? null;
		},
		bankOwnerName() {
			return this.paymentConfirmation?.bank_owner_name ?? '';
		},
		formatBankAccount() {
			const bankAccount = this.paymentConfirmation?.transfer_to ?? null;
			return `${bankAccount?.label} - ${bankAccount?.account_name} - ${bankAccount?.account_number}`;
		},
		transferDate() {
			return this.paymentConfirmation?.transfer_date ?? '';
		},
		transferAmount() {
			return this.paymentConfirmation?.transfer_amount ?? '';
		},
		paymentReceipt() {
			return this.paymentConfirmation?.payment_receipt ?? '';
		},
	},
};
</script>
